import React, { Fragment } from "react";
import LRIntegrationHeader from "../Header/LRIntegrationHeader";
import Footer from "../Footer";
import LayoutWrpper from "./LayoutWrapper";

const withLRIntegrationHeader = (Component,opts) => {
  const childComponent =  ({path,...props}) => (
	  <LayoutWrpper path={path}>
  	  <LRIntegrationHeader {...opts}>
    	  <Component {...props} />
      </LRIntegrationHeader>
      <Footer {...opts}/>
    </LayoutWrpper>  
  );
    return childComponent;
};

export default  withLRIntegrationHeader;
